import makeUrl from '@/utils/makeUrl';
const licenseApiPre = `/api/license`;
const licenseApiList = [
	// 门店营业执照
	'list',
	// 门店营业执照详情
	'show',
];
const licenseApi = {};

licenseApiList.forEach(key => {
	licenseApi[`${key}Url`] = makeUrl(licenseApiPre, key);
});

export default licenseApi;